import { render, staticRenderFns } from "./Assicurati.vue?vue&type=template&id=ca5bfce4"
import script from "./Assicurati.vue?vue&type=script&lang=js"
export * from "./Assicurati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports